'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isNumber = require('hs-lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _FormattedReactMessage = require('I18n/components/FormattedReactMessage');

var _FormattedReactMessage2 = _interopRequireDefault(_FormattedReactMessage);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StepIndicatorContainer = _styledComponents2.default.div.withConfig({
  displayName: 'StepIndicator__StepIndicatorContainer'
})(['color:', ';text-align:center;'], _colors.SLINKY);

var StepIndicator = function (_React$Component) {
  _inherits(StepIndicator, _React$Component);

  function StepIndicator() {
    _classCallCheck(this, StepIndicator);

    return _possibleConstructorReturn(this, (StepIndicator.__proto__ || Object.getPrototypeOf(StepIndicator)).apply(this, arguments));
  }

  _createClass(StepIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          current = _props.current,
          total = _props.total;


      if ((!current || !(0, _isNumber2.default)(current)) && (!total || !(0, _isNumber2.default)(total))) {
        return null;
      }

      return _react2.default.createElement(
        StepIndicatorContainer,
        null,
        _react2.default.createElement(_FormattedReactMessage2.default, {
          message: 'core.stepIndicator',
          options: {
            current: this.props.current,
            total: this.props.total
          }
        })
      );
    }
  }]);

  return StepIndicator;
}(_react2.default.Component);

StepIndicator.propTypes = {
  current: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
};
exports.default = StepIndicator;
module.exports = exports['default'];